import { IPreloadedState } from 'shared/types/redux';

export const selectLastAppliedFilter = (state: IPreloadedState) => state.searchMetaTooltip.lastAppliedFilter;
